<div class="tier-editor">
  <div class="tier-editor__head">
    <div class="tier-editor__title">
      <h4>{{ label }}</h4>
      <button pButton type="button" class="p-button-text p-button-sm ayuda-btn"
              icon="fa-solid fa-circle-question" (click)="helpRequested.emit($event)"></button>
    </div>
    <button pButton type="button" class="p-button-text p-button-sm agregar" icon="fa-solid fa-plus"
            *ngIf="!readonly" (click)="add()" pTooltip="Agregar tramo" tooltipPosition="left"></button>
  </div>
  <p class="hint" *ngIf="hint">{{ hint }}</p>

  <div class="tier-editor__note" *ngIf="reordered">
    <i class="fa-solid fa-arrow-down-1-9"></i>
    <span>Se reordenaron de mayor a menor: gana el primero que se cumple, así que un tramo por debajo de otro más chico nunca se alcanzaría.</span>
  </div>

  <div class="tier-editor__note tier-editor__note--warn" *ngIf="duplicados.length">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>Umbrales repetidos ({{ duplicados.join(', ') }}). El segundo nunca se aplica.</span>
  </div>

  <div class="tier-rows" *ngIf="tiers?.length; else vacio">
    <div class="tier-rows__head">
      <span>Si {{ thresholdLabel | lowercase }} ≥</span>
      <span>{{ valueLabel }}</span>
      <span *ngIf="!readonly"></span>
    </div>
    <div class="tier-row" *ngFor="let t of tiers; let i = index">
      <p-inputNumber [(ngModel)]="t.min" (onBlur)="onChange()" [disabled]="readonly"
                     [minFractionDigits]="thresholdStep < 1 ? 2 : 0" [maxFractionDigits]="thresholdStep < 1 ? 2 : 0"
                     [suffix]="thresholdUnit ? ' ' + thresholdUnit : ''" [showButtons]="false"
                     styleClass="tier-input"></p-inputNumber>

      <input *ngIf="mode === 'grade'" pInputText type="text" maxlength="2" [(ngModel)]="gradeTiers[i].grade"
             (blur)="onChange()" [disabled]="readonly" class="grade-input" />
      <p-inputNumber *ngIf="mode !== 'grade'" [(ngModel)]="numericTiers[i].value" (onBlur)="onChange()"
                     [disabled]="readonly" [min]="valueMin ?? undefined" [max]="valueMax ?? undefined"
                     [minFractionDigits]="valueStep < 1 ? 2 : 0" [maxFractionDigits]="valueStep < 1 ? 2 : 0"
                     [suffix]="valueUnit ? ' ' + valueUnit : ''" [showButtons]="false"
                     styleClass="tier-input"></p-inputNumber>

      <button *ngIf="!readonly" pButton type="button" class="p-button-text p-button-sm borrar"
              icon="fa-solid fa-xmark" (click)="removeAt(i)"
              pTooltip="Quitar tramo" tooltipPosition="left"></button>
    </div>
  </div>

  <ng-template #vacio>
    <p class="tier-editor__empty">Sin tramos: todos los casos usan el valor por defecto.</p>
  </ng-template>
</div>
